import { restApi } from '../../api/restApiSlice';
import { CfEntrySource, CfProbeResponse } from './CfProbeResponse';

/**
 * `entrySource` is sent rather than left to the server's default because every
 * server-side event reads `entry_source` from the snapshot the probe writes
 * (PRE-3288 / B12) — a probe that omits it makes every flow report `wizard`.
 */
export type ProbeDomainRequest = {
  domain: string;
  entrySource: CfEntrySource;
};

/**
 * Below the ingress in front of rest-api, which cuts a silent request at 60s
 * (nginx default, PRE-3287). The server's own probe budget is 8s
 * (`PROBE_BUDGET_MS` in `ProbeDomainUseCase`) for the slower of its two
 * lookups alone, so 20s leaves headroom for auth and the DB writes around it
 * while still landing well short of the gateway cut. Owning the cut here
 * means the screen's own retry message explains it, instead of a bare 504.
 */
const PROBE_TIMEOUT_MS = 20_000;

const cloudflareIntegrationApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * A mutation rather than a query: the probe opens a flow row, so it is not
     * a read, and it must not be re-run by a cache refetch behind the
     * customer's back.
     */
    probeDomain: builder.mutation<CfProbeResponse, ProbeDomainRequest>({
      query: ({ domain, entrySource }) => ({
        url: '/v3/cloudflare/probe',
        method: 'POST',
        body: { domain, entrySource },
        timeout: PROBE_TIMEOUT_MS,
      }),
    }),
  }),
});

export { cloudflareIntegrationApi };
export const { useProbeDomainMutation } = cloudflareIntegrationApi;
